import { useEffect, useState } from "react"
import { useIntl } from "react-intl";
import { useDebounce } from "../../hooks/useDebounce"
import Button from "../ui/button";
import Alert from "../alert/Alert";
import {useAssignFor} from "../../hooks/useActivationObj";
import useInactiveObj from "../../hooks/useInactiveObj";


type AssingProps = {
  userId: number;
  userName: string;
  onSuccess: () => void;
}

export default function Assign({userId, userName, onSuccess}: AssingProps) {
  const intl = useIntl();
  const [search, setSearch] = useState('');
  const fireSearch = useDebounce(search, 700);
  const [obj, setObj] = useState<{id: number, url: string} | null>(null);
  const {assignObj, success, error} = useAssignFor(userId);
  const {get, search: requestSearch, data} = useInactiveObj();

  useEffect(() => get(), [get]);

  useEffect(() => data && setObj(null), [data])

  useEffect(() => {
    if (success) {
      setObj(null);
      onSuccess();
    }
  }, [onSuccess, success])

  useEffect(() => {
    if (fireSearch) {
      fireSearch.length >= 3 && requestSearch(fireSearch);
    } else {
      get()
    }
  }, [fireSearch, get, requestSearch])

  function onAssign() {
    if (obj) {
      assignObj(obj.url);
    }
  }

  return (
    <>
      <h3 className="mb-5 text-shadow font-semibold text-xl">
        {intl.formatMessage({ id: "users.assign.heading" }, { userName })}
      </h3>
      <div className="relative">
        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
          <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="none" viewBox="0 0 20 20">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
          </svg>
        </div>
        <input
          type="search"
          id="searchForObj"
          className="my-0 input block w-full ps-10"
          placeholder={intl.formatMessage({ id: "users.assign.searchPlaceholder" })}
          onChange={e => setSearch(e.target.value)} />
      </div>
      <span className="mt-1 block text-xs text-secondary font-semibold">
        {intl.formatMessage({ id: "users.assign.hint" })}
      </span>
      {
        data && data.length > 0 ? (
          <>
            <p className="mt-3 font-semibold">
              {intl.formatMessage({ id: "users.assign.selectAndAssign" })}
            </p>
            <ul className="mt-2">
              {
                data.map(obj => (
                  <li key={obj.id} className="my-1.5"><ObjItem url={obj.url} onClick={() => setObj({id: obj.id, url: obj.url})}/></li>
                ))
              }
            </ul>
          </>
        ) : (
          <p className="mt-5 text-md font-medium">
            {intl.formatMessage({ id: "users.assign.noResults" })}
          </p>
        )
      }
      { obj && (
        <p className="mt-5 text-sm font-medium">
          {intl.formatMessage(
            { id: "users.assign.confirmAssign" },
            { url: obj.url, userName }
          )}
        </p>
      )}
      
      <Button disabled={!obj} className="mt-5" onClick={() => onAssign()}>
        {intl.formatMessage({ id: "users.assign.submit" })}
      </Button>

      { success && <Alert message={success} className="mt-3" type="success" /> }
      
      { error && <Alert message={error.message} className="mt-3" type="error" /> }
    </>
  )
}

function ObjItem ({url, onClick}: {url: string, onClick: () => void}) {
  return <button className="w-full py-2 px-3 text-start bg-white hover:bg-slate-300 active:bg-slate-300 focus:bg-slate-300 focus:outline-none" onClick={() => onClick()}>{url}</button>
}
